import styled from "styled-components";
import { Menu } from "antd";

export const StyledMenu = styled(Menu).attrs({
  mode: "horizontal",
})`
  .ant-menu-item {
    span {
      font-size: 14px;
      color: #808080;
    }
  }
  .ant-menu-item-selected {
    span {
      font-weight: bold;
      color: #313131;
    }
  }
`;
